<template>
  <div class="upload-picture-wrapper">
    <el-upload
      class="upload"
      ref="upload"
      action="https://jsonplaceholder.typicode.com/posts/"
      :file-list="fileList"
      :auto-upload="false"
      :show-file-list="false"
      :onChange="onChange"
    >
      <div slot="trigger" class="trigger-upload-box">
        <div class="trigger-upload">
          <p class="icon">+</p>
          <p>点击选择处方笺图片</p>
        </div>
      </div>
    </el-upload>
  </div>
</template>

<script>
export default {
  name: 'uploadPicture',
  data() {
    return {
      fileList: []
    };
  },
  methods: {
    onChange({ raw }) {
      const limitTypes = ['image/jpeg', 'image/png'];
      if (!limitTypes.includes(raw.type)) return this.$message.error('只能上传jpg/png图片');
      this.$emit('getImageUrl', raw);
    }
  }
};
</script>

<style lang="scss" scoped>
.upload-picture-wrapper {
  .trigger-upload-box {
    width: 368px;
    height: 521px;
    border-radius: 4px;
    border: 1px solid #ededed;
    font-size: 14px;
    background-color: #f7f9fa;
    color: #bdbdbd;
    .trigger-upload {
      .icon {
        font-size: 16px;
        margin: 207px 0 28px 0;
      }
    }
  }
}
</style>
